// === FIGURENWELT – Preisformat im Cart: "154,99 €" statt "€154,99" ===
function fw_fixCartPrices() {
  var priceNodes = document.querySelectorAll(
    '#PrestigeCart-cart-drawer .cart-price span, ' +
    '#PrestigeCart-cart-drawer .cart-item__price, ' +
    '#PrestigeCart-cart-drawer .cart-item__final-price'
  );

  priceNodes.forEach(function (el) {
    if (!el) return;

    var txt = (el.textContent || '').trim();
    if (!txt) return;

    // Nur einmal umformatieren (falls schon "154,99 €" ist, nichts tun)
    if (/\d[\d.,]*\s*€$/.test(txt)) {
      return;
    }

    // Zahl aus dem Text ziehen (154,99 / 154.99 etc.)
    var numberPart = txt.replace(/[^0-9.,]/g, '').trim();
    if (!numberPart) return;

    el.textContent = numberPart + ' €';
  });
}

// Beim ersten Laden
document.addEventListener('DOMContentLoaded', fw_fixCartPrices);

// Wenn der PrestigeCart den Warenkorb neu rendert (Artikel geändert, hinzugefügt, gelöscht)
document.addEventListener('prestigecart:updated', fw_fixCartPrices);
function fw_addToCartFirework(buttonEl) {
  // Position des Buttons ermitteln
  const btnRect = buttonEl.getBoundingClientRect();

  // Container für die Animation
  const burst = document.createElement('div');
  burst.className = 'fw-cart-burst';

  // Startposition: Mitte des Buttons
  const startX = btnRect.left + btnRect.width / 2;
  const startY = btnRect.top + btnRect.height / 2;

  burst.style.left = startX + 'px';
  burst.style.top = startY + 'px';

  // Icon (nur schwarzes Warenkorb-Symbol)
  const icon = document.createElement('div');
  icon.className = 'fw-cart-burst-icon';
  icon.textContent = '🛒'; // kannst du später durch SVG ersetzen

  // Strahlen vorbereiten
  const linesWrap = document.createElement('div');
  linesWrap.className = 'fw-cart-burst-lines';

  const lines = [];
  const lineCount = 8; // Anzahl Strahlen

  for (let i = 0; i < lineCount; i++) {
    const line = document.createElement('div');
    line.className = 'fw-cart-burst-line';
    const angle = (360 / lineCount) * i;
    line.style.transform = `rotate(${angle}deg)`;
    linesWrap.appendChild(line);
    lines.push(line);
  }

  burst.appendChild(icon);
  burst.appendChild(linesWrap);
  document.body.appendChild(burst);

  // *** WICHTIG: Nur kurzer Hopser nach oben, NICHT mehr zum Header! ***
  burst.animate(
    [
      { transform: 'translate(-50%, -10px)' },   // knapp über Button
      { transform: 'translate(-50%, -35px)' }   // etwas höher
    ],
    {
      duration: 400,
      easing: 'ease-out',
      fill: 'forwards'
    }
  );

  // Icon „platzt“ am Ende
  icon.animate(
    [
      { transform: 'scale(1)', opacity: 1 },
      { transform: 'scale(1.1)', opacity: 1 },
      { transform: 'scale(0)', opacity: 0 }
    ],
    {
      duration: 260,
      easing: 'ease-out',
      delay: 320,
      fill: 'forwards'
    }
  );

  // Explosion der Strahlen nach dem Platzen
  setTimeout(() => {
    burst.classList.add('fw-cart-burst--explode');

    lines.forEach((line, index) => {
      const delay = index * 15; // minimaler Versatz
      line.style.animationDelay = delay + 'ms';
    });

    // nach kompletter Animation aufräumen
    setTimeout(() => {
      burst.remove();
    }, 450);
  }, 320);
}
document.addEventListener('DOMContentLoaded', function () {
  const addToCartBtn = document.querySelector('[name="add"]');

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      fw_addToCartFirework(addToCartBtn);
    });
  }
});
